/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { THEME_COLORS } from '../../../../Shared/theme'
import { useTranslation } from 'react-i18next'

const MissedRevenueBreakdownBar = ({
                                       revenuesMissed,
                                       totalMissedRevenueUnavailable,
                                       totalMissedRevenueSubstituted,
                                       formatFn,
                                   }) => {
    const [t] = useTranslation()
    const total = revenuesMissed + totalMissedRevenueUnavailable + totalMissedRevenueSubstituted

    if (total <= 0) return null

    const pctMissed = (revenuesMissed / total) * 100
    const pctUnavailable = (totalMissedRevenueUnavailable / total) * 100
    const pctSubstituted = (totalMissedRevenueSubstituted / total) * 100

    const fmt = formatFn || (v => v)

    const segments = [
        {
            pct: pctMissed,
            color: THEME_COLORS.RED,
            value: revenuesMissed,
            label: t('dashboard.missed_revenues.not_acquired_orders_count', {count: ''}).trim(),
        },
        {
            pct: pctUnavailable,
            color: '#f2a3a3',
            value: totalMissedRevenueUnavailable,
            label: t('dashboard.missed_revenues.removed_items_count', {count: ''}).trim(),
        },
        {
            pct: pctSubstituted,
            color: THEME_COLORS.GREEN,
            value: totalMissedRevenueSubstituted,
            label: t('dashboard.missed_revenues.revenue_saved_count', {count: ''}).trim(),
        },
    ].filter(s => s.value > 0)

    return (
      <div css={css`
          width: 100%;
          padding: .5rem 1rem;
      `}>
          <div css={css`
              text-align: center;
              font-size: .7rem;
              font-weight: 600;
              color: rgba(0, 0, 0, .5);
              margin-bottom: .25rem;
          `}>
              {t('dashboard.missed_revenues.loss_repartition')}
          </div>

          <div css={css`
              display: flex;
              width: 100%;
              height: 24px;
              border-radius: .29rem;
              overflow: hidden;
              background: #0000001a;
              margin-bottom: .15rem;
          `}>
              {segments.map((segment, i) => (
                <div
                  key={i}
                  title={`${segment.label} ${fmt(segment.value)}`}
                  css={css`
                      width: ${segment.pct}%;
                      background-color: ${segment.color};
                      transition: width .1s ease, background-color .1s ease;
                      position: relative;
                      border-right: ${i < segments.length - 1 ? '1px solid white' : 'none'};
                  `}
                />
              ))}
          </div>

          <div css={css`
              display: flex;
              justify-content: space-around;
          `}>
              {segments.map((item, i) => (
                <div key={i} css={css`
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: .25rem;
                    flex: 1;
                    min-width: 0;
                `}>
                    <span css={css`
                        width: 8px;
                        height: 8px;
                        border-radius: 50%;
                        background-color: ${item.color};
                        flex-shrink: 0;
                        align-self: center;
                    `}/>
                    <div css={css`
                        display: flex;
                        flex-direction: column;
                        min-width: 0;
                        align-items: flex-start;
                    `}>
                        <span css={css`
                            font-size: .75rem;
                            color: rgba(0, 0, 0, .6);
                            line-height: 1.2;
                        `}>
                            {item.label}
                        </span>
                        <span css={css`
                            font-size: .75rem;
                            font-weight: 600;
                            color: ${item.color};
                            line-height: 1.2;
                        `}>
                            {fmt(item.value)}
                        </span>
                    </div>
                </div>
              ))}
          </div>
      </div>
    )
}

export { MissedRevenueBreakdownBar }
